import React from 'react';
import { midas } from '@resurs/midas';
import { Column, Columns, Container } from '../../layout';
const background = (type) => {
    switch (type) {
        case 'danger':
            return midas.boxBackgroundDanger;
        case 'warning':
            return midas.boxBackgroundWarning;
        case 'success':
            return midas.boxBackgroundSuccess;
        case 'info':
            return midas.boxBackgroundInfo;
        default:
            return midas.boxBackgroundDefault;
    }
};
const Box = ({ title, type = 'normal', transparent = false, children, dataCy, noPadding = false, }) => {
    const boxClass = transparent
        ? midas.boxTransparent
        : `${midas.boxNormal} ${background(type)}`;
    return (React.createElement(Container, null,
        React.createElement(Columns, null,
            React.createElement(Column, { col12: true, noPadding: noPadding },
                React.createElement("div", { className: midas.box, ...((dataCy && { 'data-cy': dataCy }) || {}) },
                    title && React.createElement("h5", null, title),
                    children && (React.createElement("div", { className: boxClass },
                        React.createElement(Column, { col12: true, noPadding: true }, children))))))));
};
export default Box;
